import { render, staticRenderFns } from "./ManufacturingLogbookKpiBartrendWidget.vue?vue&type=template&id=d94fb2c2"
import script from "./ManufacturingLogbookKpiBartrendWidget.vue?vue&type=script&lang=js"
export * from "./ManufacturingLogbookKpiBartrendWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports